import Menu from './Compartido/Menu.jsx';
import TextoLastMinute from './LastMinute/TextoLastMinute.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const LastMinute = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="7_Last-Minute"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />

            <TextoLastMinute
                lang={props.lang}
            />

            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default LastMinute;

